module.exports = __webpack_public_path__ + "static/media/strongher13_preview.09170f52.jpg";